import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ArrowsLeftRightIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M17.4697 5.53033C17.1768 5.23744 17.1768 4.76256 17.4697 4.46967C17.7626 4.17678 18.2374 4.17678 18.5303 4.46967L21.5283 7.4676C21.6652 7.60348 21.75 7.79184 21.75 8.00001C21.75 8.19314 21.677 8.36922 21.5571 8.50217C21.5484 8.51176 21.5395 8.52116 21.5303 8.53034L18.5303 11.5303C18.2374 11.8232 17.7626 11.8232 17.4697 11.5303C17.1768 11.2374 17.1768 10.7626 17.4697 10.4697L19.1893 8.75H9C8.58579 8.75 8.25 8.41421 8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H19.1893L17.4697 5.53033Z"
        fill="currentColor"
      />
      <path
        d="M4.81066 15.25L6.53033 13.5303C6.82322 13.2374 6.82322 12.7626 6.53033 12.4697C6.23744 12.1768 5.76256 12.1768 5.46967 12.4697L2.46967 15.4697C2.39776 15.5416 2.34351 15.6245 2.30691 15.7129C2.27024 15.8013 2.25 15.8983 2.25 16C2.25 16.1017 2.27024 16.1987 2.30691 16.2871C2.34351 16.3755 2.39776 16.4584 2.46967 16.5303L5.46967 19.5303C5.76256 19.8232 6.23744 19.8232 6.53033 19.5303C6.82322 19.2374 6.82322 18.7626 6.53033 18.4697L4.81066 16.75H15C15.4142 16.75 15.75 16.4142 15.75 16C15.75 15.5858 15.4142 15.25 15 15.25H4.81066Z"
        fill="currentColor"
      />
    </svg>
  )
}
